/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalReauthReportGeneration } from './PalReauthReportGeneration';
import {
    PalReauthReportGenerationFromJSON,
    PalReauthReportGenerationFromJSONTyped,
    PalReauthReportGenerationToJSON,
    PalReauthReportGenerationToJSONTyped,
} from './PalReauthReportGeneration';

/**
 * 
 * @export
 * @interface CreatePalReauthReportGeneration201Response
 */
export interface CreatePalReauthReportGeneration201Response {
    /**
     * 
     */
    data?: PalReauthReportGeneration;
}

/**
 * Check if a given object implements the CreatePalReauthReportGeneration201Response interface.
 */
export function instanceOfCreatePalReauthReportGeneration201Response(value: object): value is CreatePalReauthReportGeneration201Response {
    return true;
}

export function CreatePalReauthReportGeneration201ResponseFromJSON(json: any): CreatePalReauthReportGeneration201Response {
    return CreatePalReauthReportGeneration201ResponseFromJSONTyped(json, false);
}

export function CreatePalReauthReportGeneration201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePalReauthReportGeneration201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : PalReauthReportGenerationFromJSON(json['data']),
    };
}

export function CreatePalReauthReportGeneration201ResponseToJSON(json: any): CreatePalReauthReportGeneration201Response {
    return CreatePalReauthReportGeneration201ResponseToJSONTyped(json, false);
}

export function CreatePalReauthReportGeneration201ResponseToJSONTyped(value?: CreatePalReauthReportGeneration201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PalReauthReportGenerationToJSON(value['data']),
    };
}

